import React from 'react';
import { Row, Col, Button, Collapse, Form, Input, Spin } from 'antd';
import { AiFillCaretDown } from 'react-icons/ai';
import FolderSelectorTree from '../../../shared/components/FolderSelectorTree';
import { PermissionsPicker } from '../../../shared/components/PermissionsPicker';
import { usePermissionPrincipals } from '../../../hooks/usePermissionPrincipals';
import SelectFileType from './SelectFileType';
import { FileTypes } from '../../../enums/fileTypes';
import { useLegendForm } from '../../../context/MapLegendContext';
import './MapViewSteps.scss';

export interface AddDataToNewFolderProps {
  setIsVFSVisible: (v: boolean) => void;
  isVFSVisible: boolean;
  folderName: string;
  setFolderName: (v: string) => void;
  handleFileTypeChange: (v: FileTypes) => void;
  permissionValues: string[];
  setPermissionValues: (v: string[]) => void;
  /** Parent folder for the new folder, falling back to root once the listing resolves. */
  destinationFolderId: string;
  destinationLabel: string;
  isFolderMappingLoading: boolean;
}

const AddDataToNewFolder: React.FC<AddDataToNewFolderProps> = ({
  setIsVFSVisible,
  isVFSVisible,
  folderName,
  setFolderName,
  handleFileTypeChange,
  permissionValues,
  setPermissionValues,
  destinationFolderId,
  destinationLabel,
  isFolderMappingLoading,
}) => {
  const { setFolderLocation, setFolderId, setFolderS3Key } = useLegendForm();
  const { users, groups, isLoading } = usePermissionPrincipals();
  return (
    <>
      <Row className="data-portal-modal-body data-portal__row-mb" gutter={[12, 12]} align={'middle'}>
        <Col span={4}>Location:</Col>
        <Col span={20}>
          <Button onClick={() => setIsVFSVisible(true)} className="data-portal__location-btn">
            <p className="data-portal__location-text">{destinationLabel || 'Location'}</p>
            {isFolderMappingLoading ? <Spin size="small" /> : <AiFillCaretDown className="data-portal__chevron" />}
          </Button>
        </Col>
        <Col span={4}>FileType:</Col>
        <Col span={20}>
          <SelectFileType handleFileTypeChange={handleFileTypeChange} />
        </Col>

        <FolderSelectorTree
          open={isVFSVisible}
          onClose={() => setIsVFSVisible(false)}
          variant="light"
          primaryLabel="SELECT"
          initialFolderId={destinationFolderId}
          onSelect={(f) => {
            setFolderLocation(f.name);
            setFolderId(f.id);
            setFolderS3Key(f.s3Key);
          }}
        />
      </Row>

      <Collapse
        defaultActiveKey={['1']}
        className="data-portal__collapse"
        expandIconPosition="end"
        expandIcon={() => <AiFillCaretDown className="data-portal__chevron" />}
        items={[
          {
            key: '1',
            label: 'PERMISSIONS',
            children: (
              <PermissionsPicker
                users={users}
                groups={groups}
                selectedValues={permissionValues}
                onChange={setPermissionValues}
                isLoading={isLoading}
              />
            ),
          },
        ]}
      />

      <Form.Item label="Folder Name" wrapperCol={{ span: 24 }} labelCol={{ span: 24 }} className="data-portal__folder-name">
        <Input id="foldername" placeholder="Enter Folder Name..." value={folderName} onChange={(e) => setFolderName(e.target.value)} />
      </Form.Item>
    </>
  );
};

export default AddDataToNewFolder;
